<div class="hints__wrapper">
  <div class="hints__header">
    <div class="hints__title select-none">Hint</div>
    <nb-icon class="hints__close" icon="close" (click)="toggleHints()"></nb-icon>
  </div>
  <div class="hints__body">
    <ng-container>{{ currentHint$ | async }}</ng-container>
  </div>
</div>
